/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Overview_Upgrade_To_TeamInputs */



/**
* | output |
* | --- |
* | "Upgrade to Team" |
*
* @param {Sub_Overview_Upgrade_To_TeamInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_overview_upgrade_to_team = /** @type {((inputs?: Sub_Overview_Upgrade_To_TeamInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Overview_Upgrade_To_TeamInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Upgrade auf Team")
	return /** @type {LocalizedString} */ ("Upgrade to Team")
});